<template>
  <div class="personal-teach">
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button type="primary" size="medium" @click="addTeach" >代课申请</el-button>
        <advanced-class-query @search="search" />
      </div>
      <div class="search-group">
        <el-input placeholder="班级名称" v-model.trim="searchFormData.query" @keypress.enter.native="() => search()" />
        <el-button type="primary" size="medium" @click="() => search()">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:org_full_name="row">
        {{ row.org_full_name && row.org_full_name.replace(/中国儿童中心\/+/, '') }}
      </template>
      <template v-slot:action="row">
        <el-button @click="listTeach(row)" type="text" size="mini">详情</el-button>
        <template v-if="row.audit_status === 1">
          <el-button @click="auditTeach(row)" type="text" size="mini">提审</el-button>
        </template>
        <template v-if="row.audit_status === 2 || row.audit_status === 3">
          <el-button @click="passTeach(row)" type="text" size="mini">通过</el-button>
          <el-button @click="refuseTeach(row)" type="text" class="el-button--danger" size="mini">拒绝</el-button>
        </template>
        <template v-if="row.audit_status === 1 || row.audit_status === 4 || row.audit_status === 6">
          <el-button @click="editTeach(row)" type="text" size="mini">编辑</el-button>
        </template>
        <template v-if="row.audit_status === 4 || row.audit_status === 6">
          <el-button @click="delTeach(row)" type="text" class="el-button--danger" size="mini">删除</el-button>
        </template>
        <template v-if="row.audit_status !== 1">
          <el-button @click="revokeTeach(row)" v-if="hasPermission('revoke_apply')" type="text" class="el-button--danger" size="mini">撤销</el-button>
        </template>
      </template>
    </ly-table>
    <edit ref="detail" :defaultFormItemTeach="defaultFormItemTeach" @success="search" />
    <list ref="list" :defData="defaultFormItemTeachShow" />
  </div>
</template>

<script>
import { Input } from 'element-ui';
import LyTable from '@/components/LyTable';
import AdvancedClassQuery from '@/components/AdvancedClassQuery';
import { personalTeachTable } from '@/utils/tableHeaderClass';
import perMixin from '@/utils/perMixin';
import { classApi } from '@/api';
import Edit from './edit';
import List from './list';

export default {
  name: 'PersonalTeach',
  components: {
    LyTable,
    ElInput: Input,
    Edit,
    List,
    AdvancedClassQuery
  },
  mixins: [perMixin],
  data() {
    return {
      dialogVisible: false,
      searchFormData: {
        query: ''
      },
      getTableData: classApi.getClassSupply,
      tableHeader: [],
      isOnlyRead: false,
      defaultFormItemTeach: {},
      defaultFormItemTeachShow: {}
    };
  },
  mounted() {
    // this.$store.commit('PUSH_TIPS');
    this.init();
    this.search();
  },
  methods: {
    async init() {
      const res = await classApi.auditStatus();
      if (res && res.data) {
        personalTeachTable[personalTeachTable.length - 2].headerSlot.select = res.data;
        this.tableHeader = personalTeachTable;
      }
    },
    addTeach() {
      this.defaultFormItemTeach = {};
      this.$refs.detail.openDg();
    },
    search(data) {
      this.searchFormData = { ...this.searchFormData, ...data };
      this.$refs.lyTable.setData();
    },
    auditTeach(row) {
      this.$confirm('确认提审?', '提示', {
        type: 'warning'
      })
        .then(() => {
          classApi
            .classSupplySubmit({
              params: {
                class_supply_ids: [row.id]
              }
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '提审成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    revokeTeach(row) {
      this.$confirm('确认撤销?', '提示', {
        type: 'warning'
      })
        .then(() => {
          classApi
            .classSupplyRevokeSupply({
              params: {
                class_supply_ids: [row.id]
              }
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '撤销成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    delTeach(row) {
      this.$confirm('确认删除?', '提示', {
        type: 'warning'
      })
        .then(() => {
          classApi
            .controlClassSupply({
              id: row.id,
              methold: 'DELETE'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    editTeach(row) {
      this.defaultFormItemTeach = { ...row };
      this.$refs.detail.openDg();
    },
    passTeach(row) {
      this.$confirm('确认通过审核?', '提示', {
        type: 'warning'
      })
        .then(() => {
          classApi
            .classSupplyPassAudit({
              params: {
                class_supply_ids: [row.id]
              },
              type: row.audit_status === 2 ? 'center' : ''
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '审核拒绝！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    refuseTeach(row) {
      this.$confirm('确认拒绝审核?', '提示', {
        type: 'warning'
      })
        .then(() => {
          classApi
            .classSupplyRejectAudit({
              params: {
                class_supply_ids: [row.id]
              },
              type: row.audit_status === 2 ? 'center' : ''
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '审核拒绝！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    listTeach(row) {
      this.defaultFormItemTeachShow = { ...row };
      this.$refs.list.openDg();
    }
  }
};
</script>

<style lang="less" scoped>
.search-content {
  display: flex;
  justify-content: space-between;
  .search-group .el-input {
    width: 150px;
    margin-right: 20px;
  }
}
.field-label .el-checkbox {
  min-width: 100px;
  margin-bottom: 15px;
}
</style>
